import React, { useEffect, useRef, useState } from 'react'
import CourseSelection from './CourseSelection'
import CustomerForm from './CustomerForm'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import PaymentSection from './PaymentSection'
import Loader from '../../common/Loader'
import { axiosInstance } from '../config'
import { config } from '../config'
import secureLocalStorage from 'react-secure-storage'
import SlotSelection from './SlotSelection'
import InstructorSelection from './InstructorSelection'
import moment from 'moment'
import { getRequiredSessionCount, buildSlotsPayload } from './CalculateDays'
import swal from 'sweetalert'
import { getPreviousInstructor, rememberInstructorForEmail } from './returningCustomer'

const TOTAL_STEPS = 5

const STEP_LABELS = [
    'Your Details',
    'Select Course',
    'Date & Time',
    'Instructor',
    'Payment',
]

const BookingStepper = ({ step }) => (
    <div className="booking-stepper">
        <div className="booking-stepper-label-row">
            <span className="booking-stepper-label">Step {step} of {TOTAL_STEPS}</span>
            <span className="booking-stepper-step-name">{STEP_LABELS[step - 1]}</span>
        </div>
        <div className="booking-stepper-track">
            {Array.from({ length: TOTAL_STEPS }, (_, i) => (
                <span key={i} className={`booking-stepper-bar${i < step ? ' filled' : ''}`} />
            ))}
        </div>
        <div className="booking-stepper-steps">
            {STEP_LABELS.map((label, i) => (
                <span key={i} className={`booking-stepper-step${i < step ? ' active' : ''}${i === step - 1 ? ' current' : ''}`}>
                    {label}
                </span>
            ))}
        </div>
    </div>
)

const BookingProcess = () => {
    const [isFromCourse, setIsFromCourse] = useState(false)
    const [timeSlot, setTimeSlot] = useState({
        date: moment().format("YYYY-MM-DD"),
        time: ''
    })
    const [selected_sessions, setSelectedSessions] = useState([])
    const [slotsdata, setSlots] = useState([]);
    const [InstructorCourse, setInstructorCourse] = useState([]);
    const [blockedDatesByInstructor, setBlockedDatesByInstructor] = useState({});
    const location = useLocation();
    const courseData = location.state?.courseData;
    const isReschedule = location.pathname.includes('reschedule');
    const rescheduleBookingData = location.state?.bookingData || (() => {
        try {
            const raw = localStorage.getItem('last_booking');
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    })();

    useEffect(() => {
        if (courseData) {
            setSelectedCourse(courseData);
            setCarType(courseData?.cartype)
            setSelectedInstructor({})
            setTimeSlot({ date: moment().format('YYYY-MM-DD'), time: '' })
            setSelectedSessions([])
            setIsFromCourse(true)
        }
    }, [courseData])

    useEffect(() => {
        const persistData = secureLocalStorage.getItem('temp_details')
        if (persistData) {
            const restoredSessions = persistData?.selected_sessions || []
            setSelectedCourse(persistData?.selected_course)
            setcode(persistData?.code)
            setdiscount(persistData?.discount)
            setCustomerData(persistData?.customer_data)
            setCarType(persistData?.selected_course?.cartype)
            setTimeSlot(persistData?.timeSlot)
            setSelectedInstructor(persistData?.selected_instructor)
            setSelectedSessions(restoredSessions)
            setCandidateInstructorIds(persistData?.candidateInstructorIds ?? null)

            const restoredIsMultiSession = getRequiredSessionCount(persistData?.selected_course) > 1
            const missingFirstSession = restoredIsMultiSession
                ? restoredSessions.length === 0
                : !persistData?.timeSlot?.time
            if (persistData?.step === 5 && missingFirstSession) {
                setStep(3)
            } else {
                setStep(persistData?.step)
            }
        }
    }, [])

    const Navigate = useNavigate();
    const [selected_course, setSelectedCourse] = useState('')
    const [selected_instructor, setSelectedInstructor] = useState({})
    const [candidateInstructorIds, setCandidateInstructorIds] = useState(null)
    const [provisional_licence, setProvisionalLicence] = useState('')
    const [car_type, setCarType] = useState('')
    const [customer_data, setCustomerData] = useState('')
    const [returning_instructor, setReturningInstructor] = useState(null)

    useEffect(() => {
        setReturningInstructor(getPreviousInstructor(customer_data?.email))
    }, [customer_data?.email])

    const [errors, setErrors] = useState('')
    const [step, setStep] = useState(1)
    const divRef = useRef(null);
    const [course_types, setCourse] = useState([]);
    const [loading, setLoading] = useState(false);
    const [Price, setPrice] = useState("");
    const [discount, setdiscount] = useState('')
    const [code, setcode] = useState('')

    // Fetch availability for every instructor assigned to the selected course (not just one),
    // so Date & Time shows the full combined set of open slots across all of them.
    useEffect(() => {
        const courseInstructors = (selected_course?.instructors || []).filter((i) => i.status == 0 && i.trash == 0);
        setCandidateInstructorIds(null);
        if (courseInstructors.length === 0) {
            setSlots([]);
            setInstructorCourse([]);
            setBlockedDatesByInstructor({});
            return;
        }
        setLoading(true);
        Promise.all([
            Promise.all(
                courseInstructors.map((inst) =>
                    axiosInstance.get(`get-instlesson_slots/${inst.id}`)
                        .then((res) => ({ inst, res }))
                        .catch(() => ({ inst, res: null }))
                )
            ),
            axiosInstance
                .get(`get-block-dates-bulk?instructor_ids=${courseInstructors.map((i) => i.id).join(',')}`)
                .catch(() => null),
        ])
            .then(([results, blockedRes]) => {
                const mergedSlots = [];
                const mergedLessons = [];
                results.forEach(({ inst, res }) => {
                    if (!res) return;
                    const lessons = (res?.data?.data || []).filter((item) => item?.instacceptance !== "1");
                    lessons.forEach((lesson) => mergedLessons.push({ ...lesson, _instructorId: inst.id }));

                    const activeDays = res?.data?.slots?.filter((s) => s.status == 0) || [];
                    ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].forEach((day) => {
                        const existingSlot = activeDays.find((slot) => slot.days === day);
                        mergedSlots.push({
                            id: existingSlot?.id ?? null,
                            instructorid: inst.id,
                            days: day,
                            slots: existingSlot?.slots ?? "[]",
                            status: existingSlot ? existingSlot.status : "1",
                        });
                    });
                });
                setSlots(mergedSlots);
                setInstructorCourse(mergedLessons);

                const blockedMap = {};
                (blockedRes?.data?.data || []).forEach((row) => {
                    if (!blockedMap[row.instructor_id]) blockedMap[row.instructor_id] = [];
                    blockedMap[row.instructor_id].push({ start_date: row.start_date, end_date: row.end_date });
                });
                setBlockedDatesByInstructor(blockedMap);
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [selected_course?.id]);

    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`get-cources`)
            .then(res => {
                setCourse(res.data.cources.filter(course => course.status === 0).reverse())
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false))
    }, [])

    // Reschedule: skip straight to Date & Time, pre-filling the original course/instructor/customer details
    useEffect(() => {
        if (!isReschedule || !rescheduleBookingData || course_types.length === 0) return;

        const matchedCourse = course_types.find((c) => c.title === rescheduleBookingData.courseName);
        if (!matchedCourse) {
            swal('', "We couldn't find your original lesson details, please book again.", 'warning');
            setStep(1);
            return;
        }

        const matchedInstructor = matchedCourse?.instructors?.find((i) => i.id === rescheduleBookingData.instructorId) || {};

        setSelectedCourse(matchedCourse);
        setCarType(matchedCourse?.cartype);
        setSelectedInstructor(matchedInstructor);
        setCustomerData({
            fname: rescheduleBookingData.fname || '',
            email: rescheduleBookingData.email || '',
            phone: rescheduleBookingData.phone || '',
            address: rescheduleBookingData.address || '',
            postalcode: rescheduleBookingData.postalCode || '',
        });
        setTimeSlot({ date: moment().format('YYYY-MM-DD'), time: '' });
        setStep(3);
    }, [isReschedule, rescheduleBookingData, course_types])

    const sessionsRequired = getRequiredSessionCount(selected_course);

    // Instructors actually on leave for the chosen lesson date(s) - hidden
    // outright from the Instructor step, not just tagged "unavailable" like
    // the (unrelated) time-slot-taken case, since leave has a real reason
    // the customer can't work around by picking a different instructor card.
    const sessionDatesChosen = sessionsRequired > 1
        ? selected_sessions.map((s) => s.date)
        : [timeSlot?.date].filter(Boolean);
    const instructorIdsOnLeave = Object.entries(blockedDatesByInstructor)
        .filter(([, ranges]) => sessionDatesChosen.some((d) => ranges.some((r) => d >= r.start_date && d <= r.end_date)))
        .map(([id]) => Number(id));

    useEffect(() => {
        setPrice(selected_course?.price);
    }, [selected_course?.price])

    useEffect(() => {
        const discountAmount = (Price * discount) / 100;
        const NewPrice = Price - discountAmount;
        setPrice(NewPrice);
    }, [discount]);

    const validation1 = () => {
        const newErrors = {};
        if (!selected_course) newErrors.selected_course = 'Course type is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateCustomerData = () => {
        const newErrors = {};
        const { fname, email, phone, address, postalcode } = customer_data;
        if (!fname || fname.trim() === '') newErrors.fname = 'Full name is required';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) newErrors.email = 'Email is required';
        else if (!emailRegex.test(email)) newErrors.email = 'Invalid email format';
        const phoneRegex = /^[0-9]{10}$/;
        if (!phone) newErrors.phone = 'Phone number is required';
        else {
            const phoneNumber = phone.replace('+44-', '');
            if (phoneNumber.length !== 10) newErrors.phone = 'Phone number must be exactly 10 digits';
            else if (!phoneRegex.test(phoneNumber)) newErrors.phone = 'Invalid Phone number length';
        }
        if (!address || address.trim() === '') newErrors.address = 'Address is required';
        if (!postalcode) newErrors.postalcode = 'Postal code is required';
        else if (postalcode.length < 6 || postalcode.length > 10) newErrors.postalcode = 'Postal code must be between 6 and 10 characters';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const makePaymentRequest = async (data) => {
        const { url, parameters } = data;
        const params = {
            storename: parameters.storename,
            timezone: parameters.timezone,
            txntype: parameters.txntype,
            chargetotal: parameters.chargetotal,
            currency: parameters.currency,
            txndatetime: parameters.txndatetime,
            hashExtended: parameters.hashExtended,
            hash_algorithm: parameters.hash_algorithm,
            checkoutoption: parameters.checkoutoption,
            responseFailURL: parameters.responseFailURL,
            responseSuccessURL: parameters.responseSuccessURL,
        }
        try {
            // TEMP DEBUG - remove after screenshotting for the team lead.
            console.log('%cNatWest gateway redirect URL:', 'font-weight:bold', url);
            console.log('%cNatWest gateway parameters:', 'font-weight:bold', params);
            debugger; // eslint-disable-line no-debugger

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;
            Object.keys(params).forEach((key) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = params[key];
                form.appendChild(input);
            });
            document.body.appendChild(form);
            form.submit();
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const scrollToTop = () => {
        const { offsetTop } = divRef.current
        window.scrollTo({ top: offsetTop - 40, behavior: 'instant' })
    }

    const changeStep = async (e) => {
        e.preventDefault();
        scrollToTop();

        if (step === 1 && validateCustomerData()) {
            try {
                setLoading(true)
                const response = await axiosInstance.post("check-email", { email: customer_data?.email });
                if (response?.data?.success === true && response?.data?.message == "User with this email already exists") {
                    toast.error("Email Already Taken, Please use different email");
                    return;
                }
            } catch (e) {
                console.log("Error", e);
            } finally {
                setLoading(false);
            }
        }

        if (step === 2 && !validation1()) return;

        if (step === 3) {
            const sessionsChosen = sessionsRequired > 1 ? selected_sessions.length : (timeSlot?.time ? 1 : 0);
            if (sessionsChosen < 1) {
                swal('', sessionsRequired > 1
                    ? 'Please pick a date and time for your first lesson!'
                    : 'Please select a time slot!', 'warning')
                return;
            }
        }

        if (step === 4 && !selected_instructor?.id) {
            swal('', 'Please select an instructor to continue!', 'warning')
            return;
        }

        if (step === 4 && selected_instructor?.id && candidateInstructorIds && !candidateInstructorIds.includes(selected_instructor.id)) {
            swal('', 'Your selected instructor is not available for your chosen time. Please pick a new time.', 'warning')
            setStep(3);
            return;
        }

        if (step === 5 && validateCustomerData()) {
            const sessions = sessionsRequired > 1 ? selected_sessions : [{ date: timeSlot?.date, time: timeSlot?.time }];
            if (!sessions[0]?.date || !sessions[0]?.time) {
                toast.error('Please pick a lesson date and time before paying.');
                setStep(3);
                return;
            }

            try {
                const Slots = JSON.stringify(buildSlotsPayload(sessions));
                setLoading(true)
                const formData = new FormData()
                formData.append("name", customer_data.fname)
                formData.append("email", customer_data.email)
                formData.append("phone_number", customer_data.phone)
                formData.append("address", customer_data.address)
                formData.append("pincode", customer_data.postalcode)
                formData.append("course_id", selected_course?.id)
                formData.append("cartype", car_type)
                formData.append("promocode", (discount) ? code : null);
                formData.append("prolicence", 'Yes')
                formData.append("instructorid", selected_instructor?.id)
                formData.append("bookingdate", sessions[0]?.date)
                formData.append("bookingtime", sessions[0]?.time)
                formData.append("slots", Slots);

                secureLocalStorage.setItem('temp_details', {
                    customer_data, selected_course, step, code, discount,
                    timeSlot, selected_instructor, selected_sessions, candidateInstructorIds
                })

                rememberInstructorForEmail(customer_data.email, selected_instructor)

                // Save last booking for the booking details page (also used to prefill a reschedule)
                localStorage.setItem('last_booking', JSON.stringify({
                    courseName: selected_course?.title,
                    instructorName: selected_instructor?.name,
                    instructorEmail: selected_instructor?.email,
                    instructorId: selected_instructor?.id,
                    date: sessions[0]?.date,
                    time: sessions[0]?.time,
                    fname: customer_data.fname,
                    email: customer_data.email,
                    phone: customer_data.phone,
                    address: customer_data.address,
                    postalCode: customer_data.postalcode,
                    amount: `£ ${Number(Price).toFixed(2)}`,
                    status: 'confirmed',
                    image: selected_course?.image,
                }))

                const res = await axiosInstance.post(`enrollment/payment`, formData, {
                    headers: { Accept: "application/json", "Content-Type": "multipart/form-data" }
                })

                if (res.data.url) {
                    await makePaymentRequest(res.data)
                } else {
                    console.error('enrollment/payment response missing "url":', res.data);
                    toast.error('Something went wrong starting the payment. Please try again.');
                    setLoading(false)
                }
            } catch (error) {
                console.log(error)
                toast.error('Something went wrong!');
                setLoading(false)
            }
        }

        // Step navigation for steps 1-4
        if (step > 0 && step < TOTAL_STEPS) {
            if (step === 1 && validateCustomerData()) {
                setStep(prev => prev + 1)
            } else if (step === 2 && validation1()) {
                if (isFromCourse) {
                    setStep(3);
                } else {
                    setStep(prev => prev + 1)
                }
            } else if (step >= 3 && step < 4) {
                setStep(prev => prev + 1)
            } else if (step === 4) {
                setStep(prev => prev + 1)
            }
        }
    }

    // Picked an instructor from the full course roster who isn't actually free at
    // the previously chosen date/time - send back to Date & Time narrowed to just
    // this instructor's own availability so the customer can pick a time that works.
    const handleInstructorNeedsNewTime = (instructor) => {
        setTimeSlot({ date: moment().format('YYYY-MM-DD'), time: '' });
        setSelectedSessions([]);
        setCandidateInstructorIds([instructor.id]);
        setStep(3);
        toast.info(`${instructor.name} isn't available at your previously selected time. Please pick a new time.`);
    };

    const handleCourseSelect = (course) => {
        setSelectedCourse(course);
        setCarType(course?.cartype);
        setSelectedInstructor({});
        setTimeSlot({ date: moment().format('YYYY-MM-DD'), time: '' });
        setSelectedSessions([]);
    };

    const CheckCode = async () => {
        if (code !== '') {
            setLoading(true);
            try {
                const res = await axiosInstance.post("check-code", {
                    email: customer_data.email,
                    codename: code
                })
                if (res?.data?.success === false && res?.data?.message == "Promo code is not applied for existing user") {
                    toast.error("Promo Code Only Available for New Users");
                    return;
                }
                if (res?.data?.success === true) {
                    setdiscount(res?.data?.data?.discount);
                    toast.success("Promo Code Applied");
                }
                if (res?.data?.success === false) {
                    toast.error("No Promo Code Available");
                }
            } catch (Error) {
                console.log("Error", Error);
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Please add Promo Code to Apply");
        }
    }

    return (
        <>
            {loading && <Loader />}
            <div className='py-5' ref={divRef}>
                <div className="auto-container py-md-4">
                    <div className='booking_box'>
                        <div className="booking-top-note">
                            <p className='text-danger mb-0'>Are you an existing student? If so, please
                                <a href={config.StudentUrl} target='_blank' className='text-dark fw-semibold'> Login </a>
                                to your account to make a booking.</p>
                            <p className='booking-top-help mb-0'>
                                Need help? Call us on <a href="tel:0116 210 2688" className='Booking-link'>0116 210 2688</a> or <a href="tel:+44 7380 851496" className='Booking-link'>+44 7380 851496</a>
                            </p>
                        </div>
                        <div className="booking_box_inner">
                            <BookingStepper step={step} />
                                <form onSubmit={changeStep}>
                                    {step === 1 && (
                                        <CustomerForm
                                            customer_data={customer_data}
                                            setCustomerData={setCustomerData}
                                            errors={errors}
                                        />
                                    )}

                                    {step === 2 && (
                                        <CourseSelection
                                            course_types={course_types}
                                            selectedCource={selected_course}
                                            onSelectCourse={handleCourseSelect}
                                            errors={errors}
                                            returningInstructor={returning_instructor}
                                        />
                                    )}

                                    {step === 3 && (
                                        <SlotSelection
                                            timeSlot={timeSlot}
                                            setTimeSlot={setTimeSlot}
                                            slotsdata={slotsdata}
                                            InstructorCourse={InstructorCourse}
                                            blockedDatesByInstructor={blockedDatesByInstructor}
                                            sessionsRequired={sessionsRequired}
                                            selected_sessions={selected_sessions}
                                            setSelectedSessions={setSelectedSessions}
                                            candidateInstructorIds={candidateInstructorIds}
                                            setCandidateInstructorIds={setCandidateInstructorIds}
                                            carType={car_type}
                                        />
                                    )}

                                    {step === 4 && (
                                        <InstructorSelection
                                            instructors={selected_course?.instructors?.filter(i => (i.status == 0 && i.trash == 0))}
                                            selected_instructor={selected_instructor}
                                            setSelectedInstructor={setSelectedInstructor}
                                            returning_instructor={returning_instructor}
                                            availableInstructorIds={candidateInstructorIds}
                                            instructorIdsOnLeave={instructorIdsOnLeave}
                                            onInstructorNeedsNewTime={handleInstructorNeedsNewTime}
                                        />
                                    )}

                                    {step === 5 && (
                                        <PaymentSection
                                            selected_course={selected_course}
                                            price={Price}
                                            setdiscount={setdiscount}
                                            setPrice={setPrice}
                                            setstep={setStep}
                                            code={code}
                                            setcode={setcode}
                                            CheckCode={CheckCode}
                                            loading={loading}
                                            isFromCourse={isFromCourse}
                                            selected_instructor={selected_instructor}
                                            timeSlot={timeSlot}
                                            customer_data={customer_data}
                                            sessionsRequired={sessionsRequired}
                                            selected_sessions={selected_sessions}
                                        />
                                    )}

                                    {/* Navigation buttons - not shown on step 5 (has its own Pay Now footer) */}
                                    {step !== 5 && (
                                        <div className='d-flex justify-content-between flex-md-row flex-column-reverse mt-5'>
                                            {step > 1 && (
                                                <div className="btn-box text-center mt-3">
                                                    <button className="booking-btn-back" type='button'
                                                        onClick={() => setStep(step - 1)}>
                                                        <i className='bi bi-arrow-left me-2 fs-6'></i>
                                                        Back
                                                    </button>
                                                </div>
                                            )}
                                            <div className="btn-box text-center mt-3">
                                                <button className="booking-btn-next" type='submit'>
                                                    Save & Next
                                                    <i className='bi bi-arrow-right ms-2 fs-6'></i>
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BookingProcess
